/* eslint-disable max-len */
import React, { FC } from 'react'
import { Box } from '@mui/material'
import { I3Header } from '../Header'
import { I3Footer } from '../Footer'
import { LayoutBox } from '../box'
import { useCustomContext } from '../../Context'
import { IInitialContextValue } from '../../reducers/actionType/actionType'
import { useLayoutContext } from '../../Context/LayoutContext'
import PayDirForm from '../Form/payDirectForm'

export const Layout: FC = () => {
  const { apiRequest }: IInitialContextValue = useCustomContext()
  const layoutContext = useLayoutContext()

  return (
    <LayoutBox>
      <Box
        component='header'
        aria-label='Site header'
        sx={{ gridArea: 'header', border: '1px solid', borderColor: 'black' }}
      >
        <I3Header />
      </Box>

      <Box
        component='main'
        id='main-content'
        aria-label='Main content'
        sx={{
          gridArea: 'main',
          mt: 2,
          mb: 2,
          ml: layoutContext === 'desktop' ? 8 : 2,
          mr: layoutContext === 'desktop' ? 8 : 2,
        }}
      >
        <PayDirForm />
      </Box>

      <Box
        component='footer'
        aria-label='Site footer'
        sx={{
          gridArea: 'footer',
          border: '1px solid',
          borderColor: 'black',
          position: 'fixed',
          left: 0,
          bottom: 0,
          width: '100%',
          zIndex: 1,
        }}
      >
        <I3Footer />
      </Box>
    </LayoutBox>
  )
}

export default Layout
